import { CONTRACT_BUY_INTL_PREFIX } from './ContractBuy';
import React from 'react';
import { useIntl } from 'react-intl';

export const BuyInputDivider = () => {
  const intl = useIntl();
  return <div className={'buy_divider'}>{
    intl.formatMessage({ id: `${CONTRACT_BUY_INTL_PREFIX}.buyDivider` })}
  </div>;
};
